import { Button } from '@/shared';
import { AddResidentAnnouncementModal } from './modals/AddResidentAnnouncementModal';
import { useState } from 'react';
export const NoAnnouncementData = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  return (
    <div className="w-full h-[calc(80vh-200px)]">
      <div className="w-full h-full flex items-center justify-center">
        <div>
          <div className="mb-6">
            <img
              src="/assets/images/no-announcement.svg"
              className="mx-auto"
              alt=""
            />
          </div>
          <div className="mb-6 text-center">
            <h2 className="text-2xl mb-2 text-text-primary font-black">
              No house announcement yet
            </h2>
            <p className="text-xl text-text-secondary w-[70%] mx-auto">
              Add residents to start tracking program fees, expenses, and
              reports.
            </p>
          </div>
          <div className="flex items-center justify-center">
            <Button onClick={() => setShowAddModal(true)}>
              Add house announcement
            </Button>
          </div>
        </div>
      </div>

      {showAddModal && (
        <AddResidentAnnouncementModal
          isOpen={showAddModal}
          onClose={() => setShowAddModal(false)}
        />
      )}
    </div>
  );
};
